module.exports = __webpack_public_path__ + "img/cegep_beauce_appalache.1285cd77.png";